// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rkmF","label":"styles_label__nMyBC"};